"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgMarkCheck = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "m12 14 2.667 2.667 6-6M25.333 28V10.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.294 4 21.173 4 18.933 4h-5.866c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.856-.436 1.976-.436 4.216V28L16 22.667z" }))); };
exports.default = SvgMarkCheck;
//# sourceMappingURL=MarkCheck.js.map